import Vue from 'vue'

// 建议放在element-ui后面，可以覆盖element-ui样式
import '@/assets/styles/index.scss'
import '@/assets/icons'

// 导入组件
import EuLoading from '@/components/EuLoading'
import MCornerDecoration from '@/components/MCornerDecoration'
import EuEditor from '@/components/EuEditor'
import MBlockHeader from '@/components/MBlockHeader/index.vue'
import UploadFile from '@/components/UploadFile/index.vue'
import Pagination from '@/components/Pagination'
import TableColumnSettingDialog from '@/components/TableColumnSettingDialog/index.vue'
import CollapseButton from '@/components/CollapseButton/index.vue'
import EuDrawer from '@/components/EuDrawer'
import FilePreview from '@/components/FilePreview'
import TableSelectionTotalCollapse from '@/components/TableSelectionTotalCollapse'
import TableSelectionTotalCollapseItem from '@/components/TableSelectionTotalCollapse/TableSelectionTotalCollapseItem'
import StatusText from '@/components/StatusText.vue'
import TotalBlock from '@/components/TotalBlock'
import TotalBlockRow from '@/components/TotalBlock/TotalBlockRow'
import TotalBlockItem from '@/components/TotalBlock/TotalBlockItem'
import Money from '@/components/Money'
import EuSelectAddOption from '@/components/EuSelectAddOption'
import EuAutocomplete from '@/components/EuAutocomplete'

// 导入指令
import directive from '@/directive'

// 导入工具方法
import { download } from '@/utils/request'
import DataTimeRangePickerOptions from '@/utils/elementUI_DataTimeRange_PickerOptions'
import {
  enumsParse,
  enumsParseLabel,
  enumsConvertToList,
  BusinessConvertOptions,
  BuiltInRole,
  DateMode
} from '@/utils/enums'
import businessEnums from '@/utils/business-enums'
import { defaultSetting } from '@/settings'
import { hasPermission, hasRole } from '@/utils/permission'
import { 
  openNewWindow, 
  openTableColumnSettingDialog, 
  parseCurrentRouteParam, 
  parseBusinessType, 
  parseBusinessTypeParam, 
  parseBusinessCategoryAlias,
  businessTypeValueToAlias,
  getDictDefault
} from '@/utils/eu'
import { EU_TABLE_COLUMN_FIELD_OPERATION } from '@/utils/constants'
import { limitInputNumber, numToCny } from '@/utils'
import PubSubTopic from '@/utils/pubsub'
// import InjectDeadLoopDetector from '@/utils/inject-dead-loop-detector.js'

// 导入自定义的表单组件
import mFormItemComponents from '@/utils/m-form-item-components'

// 组件数组
const components = [
  { name: 'EuLoading', component: EuLoading },
  { name: 'MCornerDecoration', component: MCornerDecoration },
  { name: 'EuEditor', component: EuEditor },
  { name: 'MBlockHeader', component: MBlockHeader },
  { name: 'UploadFile', component: UploadFile },
  { name: 'Pagination', component: Pagination },
  { name: 'TableColumnSettingDialog', component: TableColumnSettingDialog },
  { name: 'CollapseButton', component: CollapseButton },
  { name: 'EuDrawer', component: EuDrawer },
  { name: 'FilePreview', component: FilePreview },
  { name: 'TableSelectionTotalCollapse', component: TableSelectionTotalCollapse },
  { name: 'TableSelectionTotalCollapseItem', component: TableSelectionTotalCollapseItem },
  { name: 'StatusText', component: StatusText },
  { name: 'TotalBlock', component: TotalBlock },
  { name: 'TotalBlockRow', component: TotalBlockRow },
  { name: 'TotalBlockItem', component: TotalBlockItem },
  { name: 'Money', component: Money },
  { name: 'EuSelectAddOption', component: EuSelectAddOption },
  { name: 'EuAutocomplete', component: EuAutocomplete },
  ...Object.keys(mFormItemComponents).map(key => ({ name: key, component: mFormItemComponents[key] }))
]

// 注册组件
components.forEach(({ name, component }) => {
  Vue.component(name, component)
})

// 注册指令
Vue.use(directive)
// 注册死循环检测
// Vue.use(InjectDeadLoopDetector)

// 注册全局方法
Vue.prototype.download = download
Vue.prototype.$DataTimeRangePickerOptions = DataTimeRangePickerOptions
Vue.prototype.$enumsParse = enumsParse
Vue.prototype.$enumsParseLabel = enumsParseLabel
Vue.prototype.$enumsConvertToList = enumsConvertToList
Vue.prototype.$enums = businessEnums
Vue.prototype.$DateMode = DateMode
Vue.prototype.$BusinessConvertOptions = BusinessConvertOptions
Vue.prototype.$BuiltInRole = BuiltInRole
Vue.prototype.defaultSetting = defaultSetting
Vue.prototype.$permission = hasPermission
Vue.prototype.$role = hasRole
Vue.prototype.$openTableColumnSettingDialog = openTableColumnSettingDialog
Vue.prototype.$tableColumnField = {
  operation: EU_TABLE_COLUMN_FIELD_OPERATION
}
Vue.prototype.$openNewWindow = openNewWindow
Vue.prototype.$limitInputNumber = limitInputNumber
Vue.prototype.$parseCurrentRouteParam = parseCurrentRouteParam
Vue.prototype.$parseBusinessType = parseBusinessType
Vue.prototype.$parseBusinessTypeParam = parseBusinessTypeParam
Vue.prototype.$parseBusinessCategoryAlias = parseBusinessCategoryAlias
Vue.prototype.$cny = numToCny
Vue.prototype.$pubsubTopic = PubSubTopic
Vue.prototype.$businessTypeValueToAlias = businessTypeValueToAlias
Vue.prototype.$dictDefault = getDictDefault


import eventBus from '@/utils/eventBus.js'
Vue.prototype.$eventBus = eventBus
